let initialized = false;

function installPostHogStub(apiHost) {
  if (window.posthog && window.posthog.__SV) return window.posthog;

  const posthog = (window.posthog = window.posthog || []);
  posthog._i = posthog._i || [];
  posthog.init = function init(token, config, name) {
    const instance = name ? (posthog[name] = []) : posthog;
    instance.people = instance.people || [];

    const methods = [
      "capture", "register", "register_once", "unregister", "reset",
      "get_distinct_id", "get_session_id", "opt_in_capturing",
      "opt_out_capturing", "has_opted_in_capturing",
      "has_opted_out_capturing", "set_config", "debug",
    ];

    for (const method of methods) {
      instance[method] = (...args) => instance.push([method, ...args]);
    }

    posthog._i.push([token, config, name]);
  };
  posthog.__SV = 1;

  const script = document.createElement("script");
  script.async = true;
  script.crossOrigin = "anonymous";
  script.src = `${apiHost.replace(".i.posthog.com", "-assets.i.posthog.com")}/static/array.js`;
  document.head.appendChild(script);

  return posthog;
}

export function initAnalytics() {
  if (initialized || typeof window === "undefined") return;

  const allowedHosts = new Set(["app.foresthub.app"]);
  if (!allowedHosts.has(window.location.hostname)) return;

  const key = process.env.REACT_APP_POSTHOG_KEY;
  if (!key) return;

  const apiHost = process.env.REACT_APP_POSTHOG_HOST || "https://eu.i.posthog.com";
  const posthog = installPostHogStub(apiHost);

  posthog.init(key, {
    api_host: apiHost,
    defaults: "2026-05-30",
    cookieless_mode: "always",
    persistence: "memory",
    autocapture: false,
    capture_pageview: "history_change",
    capture_pageleave: false,
    capture_performance: true,
    disable_session_recording: true,
    disable_surveys: true,
    advanced_disable_feature_flags: true,
    person_profiles: "identified_only",
  });

  initialized = true;
}
